import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: auto;

  height: 100%;
  position: relative;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-right: 28px;
  margin-bottom: auto;
  overflow-y: auto;
  height: 100%;
  position: relative;

  &.align__center {
    align-items: center;
  }

  &.align__flex-start {
    align-items: flex-start;
  }
`;

export const AlignmentButton = styled.button`
  width: 30px;
  height: 30px;
  background: #e9ebee;
  border-radius: 15px;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px;
  margin-left: 320px;

  .first-line,
  .second-line,
  .third-line {
    background: #5e6876;
    border-radius: 2px;
    height: 2px;
    width: 100%;
    margin: 1.2px 0;
  }

  .second-line {
    width: 12px;
  }

  .third-line {
    width: 6px;
  }

  &.align__center {
    align-items: center;
  }

  &.align__flex-start {
    align-items: flex-start;
  }
`;

export const Header = styled.div`
  width: 100%;
  margin-bottom: 6px;

  .header__name {
    text-align: center;
    font: normal normal normal 16px/30px Fira Sans;
    letter-spacing: 0px;
    color: #515f75;
    min-width: 60px;
    display: inline-block;
  }
`;

export const TagBar = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  width: 100%;
  max-width: 100%;
  background: #444f5f;
  border-radius: 5px;

  .tag__frequency {
    text-align: center;
    font: normal normal normal 21px/26px Fira Sans;
    letter-spacing: 0px;
    color: #ffaa00;
    background: transparent;
    border-radius: 5px;
    margin: 0 10px;
  }

  .tag__frequency-higher {
    text-align: center;
    font: normal normal normal 21px/26px Fira Sans;
    letter-spacing: 0px;
    color: white;
    background: transparent;
    border-radius: 5px;
    margin: 0 10px;
  }

  .tag__name {
    text-align: left;
    font: normal normal normal 16px/26px Fira Sans;
    line-height: 18px;
    letter-spacing: 0px;
    color: #ffaa00;
    background: #2f3845;
    border-radius: 5px;
    display: flex;
    align-items: center;
    min-height: 50px;

    .tag__name-span {
      position: absolute;
      margin-left: 10px;
    }
  }

  &.tag__most-frequently-1 {
    background: #444f5f;

    .tag__name {
      background: #2f3845;
    }
  }

  &.tag__most-frequently-2 {
    background: #636c7a;

    .tag__name {
      background: #444f5f;
    }
  }

  &.tag__most-frequently-3 {
    background: #f2f3f5;

    .tag__name {
      background: #e4e6ea;
      color: #5e6876;
    }
  }
`;
